import React from 'react';
import { generateTooltipContent, TableColumnTooltip } from 'app/common/table/TableColumnTooltipComponent';

export class StandardColumnTooltips {
    public static readonly ADEP: TableColumnTooltip = { content: <span>Aerodrome of Departure</span> };
    public static readonly CFMU_TYPE: TableColumnTooltip = {
        title: 'Type of Flight Data',
        content: generateTooltipContent([
            ['A', 'ATC Activated'],
            ['I', 'IFPL'],
            ['P', 'Predicted Flight Data'],
            ['R', 'RPL'],
            ['M', 'Mini Flight Data'],
            ['T', 'TACT Activated (ATOT <= NOW)'],
            ['t', 'TACT Activated (ATOT > NOW)'],
            ['E', 'Terminated'],
        ]),
    };
    public static readonly ADES: TableColumnTooltip = { content: 'Aerodrome of Destination' };
    public static readonly ALT1: TableColumnTooltip = { content: '1st Alternate Aerodrome' };
    public static readonly ALT2: TableColumnTooltip = { content: '2nd Alternate Aerodrome' };

    public static readonly AO: TableColumnTooltip = { content: 'Aircraft Operator' };
    public static readonly AOWIR: TableColumnTooltip = {
        title: 'AO What If Reroute Indicator',
        content: generateTooltipContent([
            ['N', 'Cannot be rerouted'],
            ['T', 'Try is allowed'],
            ['A', 'Apply and try are allowed'],
        ]),
    };
    public static readonly ARCID: TableColumnTooltip = { content: 'Aircraft Identification' };
    public static readonly AOBT: TableColumnTooltip = { content: 'Actual Off Block Time' };
    public static readonly ATA: TableColumnTooltip = { content: 'Actual Time of Arrival' };
    public static readonly ATO: TableColumnTooltip = { content: 'Actual Time Over' };
    public static readonly ATOT: TableColumnTooltip = { content: 'Actual Take-Off Time' };
    public static readonly ATOT_TTOT: TableColumnTooltip = {
        content: 'Take-Off Time info from Aerodrome of Departure',
    };
    public static readonly ATYPE: TableColumnTooltip = { content: 'ICAO Identifier of the Aircraft Type' };
    public static readonly AVOIDED_REGULATIONS: TableColumnTooltip = { content: 'Avoided Regulations' };

    public static readonly CDM_EOBT: TableColumnTooltip = { content: 'CDM Estimated Off-Block Time' };
    public static readonly CPX: TableColumnTooltip = { content: 'Complexity' };
    public static readonly CTA: TableColumnTooltip = { content: 'Controlled Time of Arrival' };
    public static readonly CTO: TableColumnTooltip = { content: 'Calculated Time Over' };
    public static readonly CTOT: TableColumnTooltip = { content: 'Calculated Take-Off Time' };
    public static readonly CTOT_LIMIT: TableColumnTooltip = {
        title: 'CTOT Limit',
        content: generateTooltipContent([
            ['t', 'Forced by Tower'],
            ['f', 'Forced by NMOC'],
            ['w', 'Was Forced by NMOC'],
            ['c', 'Forced by CHAMAN'],
            ['s', 'Forced by STAM'],
            ['e', 'Slot Extension'],
            ['V', 'By violation'],
            ['X', 'By violation/zero rate/RVR'],
        ]),
    };
    public static readonly D: TableColumnTooltip = { content: 'Data Set' };
    public static readonly DELAY: TableColumnTooltip = { content: 'ATFM Delay in minutes' };
    public static readonly DELTA_TIME: TableColumnTooltip = { content: 'Delta Time' };
    public static readonly DELTA_LEVEL: TableColumnTooltip = { content: 'Delta Level' };
    public static readonly DELTA_POSITION: TableColumnTooltip = { content: 'Delta Position' };
    public static readonly DIFF: TableColumnTooltip = {
        title: 'Difference Indicator',
        content: generateTooltipContent([
            ['++', 'In second query only'],
            ['--', 'In first query only'],
            ['* ', 'In both queries with differences'],
        ]),
    };
    public static readonly DIVERTED: TableColumnTooltip = { content: 'Diverted indicator' };

    public static readonly EET: TableColumnTooltip = { content: 'Estimated Elapsed Time' };
    public static readonly EOBT: TableColumnTooltip = { content: 'Estimated Off-Block Time' };
    public static readonly ENTRY_FL: TableColumnTooltip = { content: 'Entry Flight Level' };
    public static readonly ENTRY_TIME: TableColumnTooltip = { content: 'Time of Entry into the Location' };
    public static readonly ETA: TableColumnTooltip = { content: 'Estimated Time of Arrival' };
    public static readonly ETO_CTO: TableColumnTooltip = { content: 'Estimated/Calculated Time Over' };
    public static readonly ETOT: TableColumnTooltip = { content: 'Estimated Take-Off Time' };
    public static readonly ETOT_CTOT: TableColumnTooltip = { content: 'Estimated or Calculated Take-Off Time' };
    public static readonly EXCLUDED_REGULATIONS: TableColumnTooltip = { content: 'Excluded Regulations' };
    public static readonly EXCLUSION_FROM_REGULATIONS: TableColumnTooltip = {
        content: 'Number of Regulations from which the Flight is Excluded',
    };
    public static readonly EXIT_FL: TableColumnTooltip = { content: 'Exit Flight Level' };
    public static readonly EXIT_TIME: TableColumnTooltip = { content: 'Time of Exit from the Location' };
    public static readonly FLIGHT_EVENT: TableColumnTooltip = { content: 'Flight Event' }; // too numerous to list possible values (see FlightUtils.toFlightEventTypeExplanation instead)
    public static readonly FLIGHT_STATE: TableColumnTooltip = {
        title: 'Flight State',
        content: generateTooltipContent([
            ['AA', 'ATC Activated'],
            ['CA', 'Cancelled'],
            ['FI', 'Filed'],
            ['FS', 'Filed Slot Allocated'],
            ['SI', 'Filed Slot Issued'],
            ['PL', 'Planned'],
            ['PR', 'Planned Rerouted'],
            ['PS', 'Planned Slot Allocated'],
            ['SR', 'Planned Slot Allocated Rerouted'],
            ['SU', 'Suspended'],
            ['TA', 'TACT Activated'],
            ['TE', 'Terminated'],
        ]),
    };
    public static readonly HOTSPOT_NUM: TableColumnTooltip = {
        content: 'Number of Hotspots in which the flight is caught',
    };
    public static readonly IATA_ARCID: TableColumnTooltip = { content: 'IATA Aircraft Identification' };

    public static readonly IOBT: TableColumnTooltip = { content: 'Initial Off-Block Time' };
    public static readonly INTRUDER: TableColumnTooltip = {
        title: 'Intruder',
        content: generateTooltipContent([
            ['H', 'Horizontal deviation'],
            ['V', 'Vertical deviation'],
            ['M', 'Mixed deviation'],
        ]),
    };
    public static readonly LAST_VALIDITY: TableColumnTooltip = {
        title: 'Last Validity to remain IFPS compliant',
        content: generateTooltipContent([
            ['<HH:MM', 'flight profile becomes invalid after HH:MM'],
            ['+HH:MM', 'flight profile valid until HH:MM (check time limit)'],
            ['?..:..', 'flight profile validity has not been checked'],
        ]),
    };
    public static readonly LOAD_STATE: TableColumnTooltip = {
        title: 'Load State',
        content: generateTooltipContent([
            ['L', 'Low'],
            ['H', 'High'],
            ['O', 'Overloaded'],
            ['P', 'Peak'],
            ['S', 'Sustained'],
        ]),
    };
    public static readonly MANUAL_FORCE: TableColumnTooltip = { content: 'Slot Allocation has been Manually Forced' };
    public static readonly MEA: TableColumnTooltip = { content: 'Identifier of the Most Penalising Measure' };
    public static readonly MPR: TableColumnTooltip = { content: 'Identifier of the Most Penalising Regulation' };
    public static readonly MPR_CAUSE: TableColumnTooltip = { content: 'Cause of the most Penalising Regulation' };
    public static readonly MSG: TableColumnTooltip = { content: 'Last Message Sent or Received' };
    public static readonly OAO: TableColumnTooltip = { content: 'Operating Aircraft Operator' };
    public static readonly OTHER_REGS: TableColumnTooltip = { content: 'If Other Regulations Apply' };
    public static readonly PAX: TableColumnTooltip = { content: 'Number of Passengers' };
    public static readonly PROBABILITY_IN_QUERY: TableColumnTooltip = { content: 'Probability' };
    public static readonly READY: TableColumnTooltip = {
        title: 'Ready Status',
        content: generateTooltipContent([
            ['I', 'Flight is in RFI mode'],
            ['S', 'SIP Wanted Message mode is on'],
            ['R', 'Flight is ready to depart'],
        ]),
    };
    public static readonly REG_ID: TableColumnTooltip = { content: 'Registration Mark' };
    public static readonly ROUTE_LEN: TableColumnTooltip = { content: 'Route Length' };
    public static readonly RRT_OPP: TableColumnTooltip = {
        title: 'Rerouting Opportunity Indicator',
        content: generateTooltipContent([
            ['E', 'Executed'],
            ['I', 'Interesting'],
            ['O', 'Opportunity'],
        ]),
    };
    public static readonly RRT_INDICATOR: TableColumnTooltip = {
        title: 'Rerouting Indicator',
        content: generateTooltipContent([
            ['N', 'Not rerouted'],
            ['M', 'ATFM executed'],
            ['C', 'ATFCM proposal'],
            ['A', 'ATC rerouting'],
            ['R', 'CDR rerouting'],
            ['F', 'Flight Eff. rerouting'],
            ['S', 'STAM rerouting'],
            ['O', 'AO rerouting'],
            ['--', '-------'],
            ['P', 'Produced'],
            ['E', 'Executed'],
            ['T', 'Timed out'],
            ['R', 'Rejected'],
        ]),
    };
    public static readonly RFL: TableColumnTooltip = { content: 'Actual Requested Flight Level' };
    public static readonly SIP: TableColumnTooltip = { content: 'Slot Improvement Proposal' };
    public static readonly STATUS: TableColumnTooltip = {
        title: 'Status of the Flight',
        content: generateTooltipContent([
            ['LF', 'Late Filer'],
            ['LU', 'Late Updater'],
            ['LFU', 'Late Filer and Updater'],
        ]),
    };
    public static readonly SUSPEND: TableColumnTooltip = {
        title: 'Suspension Status',
        content: generateTooltipContent([
            ['ST', 'SIT Time Out'],
            ['SM', 'Slot Missed'],
            ['RC', 'FCM required'],
            ['DC', 'Delay Threshold exceeded'],
            ['TV', 'RVR'],
            ['NR', 'Not Reported as airborne'],
            ['RV', 'FP Revalidation'],
            ['MS', 'Manual Suspension'],
            ['AS', 'Airport Suspension'],
        ]),
    };
    public static readonly TAXI: TableColumnTooltip = { content: 'FTFM Taxi-Time' };
    public static readonly TAXI_B: TableColumnTooltip = { content: 'Actual Taxi-Time' };
    public static readonly TOBT: TableColumnTooltip = { content: 'Target Off-Block Time' };
    public static readonly TSAT: TableColumnTooltip = { content: 'Target Start-Up Approval Time' };
    public static readonly TTO: TableColumnTooltip = { content: 'Target Time Over' };
    public static readonly TREND_IN: TableColumnTooltip = {
        title: 'Trend In',
        content: generateTooltipContent([
            ['=', 'Cruise'],
            ['/', 'Climb'],
            ['\\', 'Descent'],
        ]),
    };
    public static readonly TREND_MIDDLE: TableColumnTooltip = {
        title: 'Middle Trend',
        content: generateTooltipContent([
            ['=', 'Cruise'],
            ['/', 'Climb'],
            ['\\', 'Descent'],
        ]),
    };
    public static readonly TREND_OUT: TableColumnTooltip = {
        title: 'Trend Out',
        content: generateTooltipContent([
            ['=', 'Cruise'],
            ['/', 'Climb'],
            ['\\', 'Descent'],
        ]),
    };
    public static readonly xTA: TableColumnTooltip = { content: 'Estimated/Calculated/Actual Time of Arrival' };
    public static readonly HIGHLIGHT_INDICATOR: TableColumnTooltip = { content: 'Highlight Indicator' };

    public static readonly MEASURE_CHERRY_PICKING: TableColumnTooltip = { content: 'Cherry Picking?' };
    public static readonly MEASURE_EXTERNALLY_EDITABLE: TableColumnTooltip = { content: 'Externally editable?' };
    public static readonly MEASURE_FMP_CREATED: TableColumnTooltip = { content: 'Created by FMP?' };
    public static readonly MEASURE_HOTSPOT: TableColumnTooltip = { content: 'Associated Hotspot' };
    public static readonly MEASURE_ID: TableColumnTooltip = { content: 'Measure Identifier' };
    public static readonly MEASURE_MCDM_REQUIRED: TableColumnTooltip = { content: 'MCDM Required?' };
    public static readonly MEASURE_MCDM_STATE: TableColumnTooltip = { content: 'MCDM State' };
    public static readonly MEASURE_PROTECTED_LOCATION: TableColumnTooltip = {
        content: 'Location protected by this measure',
    };

    public static readonly MEASURE_REMARK: TableColumnTooltip = { content: 'Remark' };
    public static readonly MEASURE_SCENARIO: TableColumnTooltip = { content: 'Measure Scenario' };
    public static readonly MEASURE_STATUS: TableColumnTooltip = { content: 'Measure Status' };
    public static readonly MEASURE_SUBTYPE: TableColumnTooltip = {
        title: 'Measure Subtype',
        content: generateTooltipContent([
            ['AHRER', 'Airborne Rerouting'],
            ['ALCAP', 'Airborne Level Cap'],
            ['GDLAY', 'Ground Delay'],
            ['GHRER', 'Ground Rerouting'],
            ['GLCAP', 'Ground Level Cap'],
            ['TRAIL', 'Miles In Trail'],
            ['MDI', 'Minimum Departure Interval'],
            ['TNA', 'TakeOff Not After'],
            ['TNB', 'TakeOff Not Before'],
            ['TPCHG', 'Terminal Procedure Change'],
        ]),
    };
    public static readonly MEASURE_TYPE: TableColumnTooltip = { content: 'Measure Type' };
    public static readonly MEASURE_LAST_UPDATE: TableColumnTooltip = {
        title: 'Last Update',
        content: generateTooltipContent([
            ['c', 'Create'],
            ['u', 'Update'],
            ['x', 'Cancel'],
        ]),
    };
    public static readonly TRAFFIC_VOLUME: TableColumnTooltip = { content: 'Traffic Volume' };
    public static readonly REFERENCE_LOCATION: TableColumnTooltip = { content: 'Related Reference Location' };
    public static readonly TRAFFIC_VOLUME_SET: TableColumnTooltip = { content: 'Traffic Volume Set' };
    public static readonly WEF: TableColumnTooltip = { content: 'From Time' };
    public static readonly UNT: TableColumnTooltip = { content: 'Until Time' };
    public static readonly REGULATION_LFRS: TableColumnTooltip = {
        title: 'Link State',
        content: generateTooltipContent([
            ['A', 'AutoLink'],
            ['F', 'FCM Mandatory'],
            ['L', 'AutoLink + Linked Regulations'],
            ['M', 'Linked Regulations'],
            ['R', 'RVR'],
            ['S', 'Shift'],
        ]),
    };
    public static readonly REGULATION_NORMAL_RATES: TableColumnTooltip = {
        title: 'Regulation Normal Rates',
        content: generateTooltipContent([
            ['Entry:', 'Normal rate'],
            ['Occupancy:', 'Peak rate'],
            ['+', 'Multiple constraints, min rate is shown'],
        ]),
    };
    public static readonly REGULATION_PENDING_RATES: TableColumnTooltip = {
        title: 'Regulation Pending Rates',
        content: generateTooltipContent([
            ['Entry:', 'Pending rate'],
            ['Occupancy:', 'Rate + % pending'],
        ]),
    };
    public static readonly REGULATION_EOC: TableColumnTooltip = {
        content: generateTooltipContent([
            ['E', 'Entry'],
            ['O', 'Occupancy'],
            ['C', 'Cherry Pick'],
        ]),
    };
    public static readonly REGULATION_REASON: TableColumnTooltip = { content: 'Regulation Reason' };
    public static readonly REGULATION_RATES: TableColumnTooltip = { content: 'Regulation Rates' };
    public static readonly REGULATION_WINDOW_WIDTH: TableColumnTooltip = { content: 'Window Width' };

    public static readonly APPLICABLE_SCENARIOS: TableColumnTooltip = { content: 'Number of Applicable Scenarios' };
    public static readonly MCDM: TableColumnTooltip = { content: 'Measure CDM State' };
    public static readonly IN_TV_TIME: TableColumnTooltip = { content: 'In Traffic Volume Time' };
    public static readonly MEASURE_KINDS: TableColumnTooltip = {
        title: 'MCDM Measure Kind',
        content: generateTooltipContent([
            ['d/D', 'Involved in one/several regulations with MCDM'],
            ['r/R', 'Involved in one/several re-routings with MCDM'],
            ['m/M', 'Involved in one/several MCDM only measures'],
        ]),
    };
    public static readonly COBT: TableColumnTooltip = { content: 'Calculated Off Block Time' };
    public static readonly TURNAROUND_IMPACT_MARGIN: TableColumnTooltip = {
        title: 'Turnaround Impact Margin',
        content: 'Calculated based on the next known flight',
    };
    public static readonly MINIMUM_TURNAROUND_TIME: TableColumnTooltip = { content: 'Minimum Turnaround Time' };
    public static readonly PROPOSAL_CONTEXT: TableColumnTooltip = { content: 'Proposal Context' };
    public static readonly KNOWN_PROPOSAL_CONTEXTS: TableColumnTooltip = { content: 'Known Proposal Contexts' };
    public static readonly TTA_ATO: TableColumnTooltip = { content: 'Actual Time Over' };
    public static readonly TTA_PT: TableColumnTooltip = { content: 'Most Penalising Target Time Location' };
    public static readonly TTA_RTO: TableColumnTooltip = { content: 'Most Penalising Target Time Over' };

    public static readonly SCENARIO_ID: TableColumnTooltip = { content: 'Scenario Identifier' };

    public static readonly EHELP_DESK_TICKET: TableColumnTooltip = {
        title: 'eHelp Desk ticket type',
        content: generateTooltipContent([
            ['EXCLUDE', 'Exclude from regulation'],
            ['EXTEND', 'Extend slot'],
            ['FORCE', 'Force in regulation'],
            ['IMPROVE', 'Improve slot'],
            ['INCLUDE', '(Re)include in regulation'],
            ['INFO', 'Request for Information'],
            ['OTHER', 'Other request'],
            ['SWAP', 'Slot Swap'],
            ['RRT ADD', 'Add to rerouting measure'],
            ['RRT RMV', 'Remove from rerouting measure'],
            ['UNFORCE', 'Undo force in regulation'],
        ]),
    };

    public static readonly RUNWAY_VISUAL_RANGE: TableColumnTooltip = { content: 'Runway visual range' };
    public static readonly WAKE_TURBULENCE_CATEGORY: TableColumnTooltip = {
        title: 'Wake Turbulence Category',
        content: generateTooltipContent([
            ['L', 'Light'],
            ['M', 'Medium'],
            ['H', 'Heavy'],
            ['J', 'Super'],
        ]),
    };
}
